interface Props {
  size?: number
  label?: string
}

export function LoadingSpinner({ size = 24, label = 'Carregando…' }: Props) {
  return (
    <div
      role="status"
      aria-label={label}
      style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)', color: 'var(--color-gray-600)' }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        style={{ animation: 'spin 0.8s linear infinite' }}
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity="0.2" />
        <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </svg>
      <span style={{ fontSize: 'var(--font-size-sm)' }}>{label}</span>
    </div>
  )
}

export function PageLoading() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 'var(--space-16)' }}>
      <LoadingSpinner size={32} />
    </div>
  )
}
